module.exports = __webpack_public_path__ + "static/VSF-c84f85e2a4e1f4cc728b8b9ef933cb5d.png";